import { Component } from "react"
import { inject, observer } from 'mobx-react';

import withLocalization from '~/hoc/withLocalization';

import { timeFormat, shortDateFormat } from '~/utils/dateFormat'

class MemberAvailability extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { obj, commonStore, t } = this.props;
        const dateTimeRules = commonStore.getDateTimeRules();
        return (
            <>
                <div className="border-789BD0 border-radius-10 mt-10 p-3">
                    <div className='row'>
                        <table className='col-md-12'>
                            <tr>
                                <th className='col-md-3 text-center'>{t("Date")}</th>
                                <th className='col-md-3 text-center'>{t("Employee")}</th>
                                <th className='col-md-3 text-center'>{t("Availability")}</th>
                                <th className='col-md-3 text-center'>{t("Time")}</th>
                            </tr>
                        </table>
                    </div>
                    <hr className="mt-10 mb-10" style={{ borderTop: '1.5px solid #ccc' }} />
                    {obj && obj.map((obj, index) =>
                        <div className='row' key={index}>
                            <table className='col-md-12'>
                                <tr>
                                    {index == 0 ?
                                        <td className='col-md-3 text-center'>{shortDateFormat(obj.for_date, dateTimeRules)}</td>
                                        :
                                        <td className='col-md-3 text-center'></td>
                                    }
                                    <td className='col-md-3 text-center'>{obj.first_name + " " + obj.last_name}</td>
                                    <td className={`col-md-3 text-center ${obj.availability_type === 'available' ? 'text-success' : 'text-danger'}`} >
                                        {obj.availability_type === 'available' ? t("Available") : t("Unavailable")}
                                    </td>
                                    {((obj.from == 0 || obj.from == null) && (obj.to == 0 || obj.to == null)) ?
                                        <td className='col-md-3 text-center'>{t("Full day")}</td>
                                        :
                                        <td className='col-md-3 text-center'>{t("from")} {timeFormat(obj.from, dateTimeRules)} {t("to")} {timeFormat(obj.to, dateTimeRules)}</td>
                                    }
                                </tr>
                            </table>
                        </div>
                    )}
                </div>
            </>
        )
    }
}
export default inject('commonStore')(withLocalization(observer(MemberAvailability)));